// Ekran 13 — Profilim API istemcisi.

import { api } from '../../lib/api'

export type Rol = 'tesis_sorumlusu' | 'operator' | 'laborant' | 'muhasebe'
export type KullaniciDurumu = 'aktif' | 'pasif'

export type Profil = {
  id: string
  eposta: string
  ad: string
  unvan: string | null
  tel: string | null
  dil: string
  rol: Rol
  rolAdi: string
  durum: KullaniciDurumu
  /** Erişimli AKTİF tesislerin ili — "Konya · Karaman". */
  iller: string[]
  sonGiris: string | null
  /** Son girişin ham user-agent'ı — sol karttaki "· Chrome" eki (ref 13:513). */
  sonGirisCihaz: string | null
  sifreDegisimZamani: string | null
  sifrePolitikaGun: number
  hesapAcilisi: string
  yetkiOnay: boolean
  yetkiStorno: boolean
}

export type ProfilGuncelle = {
  ad: string
  unvan: string | null
  tel: string | null
  dil: string | null
}

export type BildirimOlayi = { anahtar: string; ad: string; aciklama: string | null }
export type BildirimKanali = { anahtar: string; ad: string }
export type BildirimTercihi = { olay: string; kanal: string; acik: boolean }

export type BildirimMatrisi = {
  olaylar: BildirimOlayi[]
  kanallar: BildirimKanali[]
  tercihler: BildirimTercihi[]
}

export type Oturum = {
  id: string
  cihaz: string | null
  ip: string | null
  baslangic: string
  sonEtkinlik: string
  aktif: boolean
  buOturum: boolean
}

export const profil = {
  getir: () => api<Profil>('/api/profil'),

  guncelle: (govde: ProfilGuncelle) =>
    api<Profil>('/api/profil', { yontem: 'PUT', govde }),

  sifreDegistir: (govde: { mevcut: string; yeni: string }) =>
    api<{ guncellendi: boolean; kapatilanOturum: number; sifreDegisimZamani: string }>(
      '/api/profil/sifre',
      { yontem: 'PUT', govde },
    ),

  bildirimler: () => api<BildirimMatrisi>('/api/profil/bildirimler'),

  bildirimleriYaz: (govde: BildirimTercihi[]) =>
    api<BildirimMatrisi>('/api/profil/bildirimler', { yontem: 'PUT', govde }),
}

export const oturumlar = {
  liste: () => api<Oturum[]>('/api/auth/oturumlar'),

  sonlandir: (id: string) =>
    api<{ sonlandirildi: boolean }>(`/api/auth/oturumlar/${id}`, { yontem: 'DELETE' }),

  digerleriniKapat: () =>
    api<{ sonlandirilan: number }>('/api/auth/oturumlar', { yontem: 'DELETE' }),
}
